export const NETWORK_CONNECTIONS = {
  ETHERNET: "Ethernet",
  WIFI: "Wifi",
  "4G": "4G Mobile",
};

export const NETWORK_CONNECTION_OPTIONS = Object.entries(
  NETWORK_CONNECTIONS
).map(([val, lab]) => {
  return {
    value: val,
    label: lab,
  };
});

export const GRID_PHASES = [
  null,
  "Single Network Phase",
  "Two Network Phases",
  "Three Network Phases",
];

export const SOLAR_PHASE_OPTIONS = [
  {
    value: 1,
    label: "Single Phase",
  },
  {
    value: 3,
    label: "Three Phase",
  },
];

export const serializeDesign = (design, edmiSerial) => {
  return {
    edmiSerials: edmiSerial ? [edmiSerial] : [],
    gridPhases: design.gridPhases.value,
    inverterSystems: Object.entries(design.inverterSystems).reduce(
      (mapped, [uid, system]) => {
        mapped[uid] = {
          inverter: system.inverter.value,
          pvConnected: system.pvConnected.value,
          pvPhases: system.pvPhases.value,
          battery: system.battery.value,
        };
        return mapped;
      },
      {}
    ),
  };
};



// WEBPACK FOOTER //
// ./src/containers/kit/KitConstants.js